import { useEffect } from 'react';
import sentry from 'Integrations/Sentry';

export const dispatchWindowEvent = (eventName, data) => {
  window.dispatchEvent(new CustomEvent(eventName, { detail: data }));
};

export default function useWindowEvent(eventName, onEvent, dependencies) {
  useEffect(() => {
    const callback = (evt) => {
      try {
        onEvent(evt, ...dependencies);
      } catch (err) {
        sentry.createSentryErrorLog(err);
      }
    };

    window.addEventListener(eventName, callback);

    return () => {
      window.removeEventListener(eventName, callback);
    };
  }, [...dependencies]);
}
